import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { catchError } from 'rxjs/internal/operators';
import { empty } from 'rxjs/internal/observable/empty';
import { MatDialog } from '@angular/material';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';

@Component({
  selector: 'app-catalogs-new-catalog-creation-card',
  templateUrl: './catalogs-new-catalog-creation-card.component.html',
  styleUrls: ['./catalogs-new-catalog-creation-card.component.scss']
})
export class CatalogsNewCatalogCreationCardComponent implements OnInit, OnDestroy {

  centers;
  desks;
  mCatalogDevices;
  staffDevices;
  products;
  selectedCenters;
  selectedDesks;
  selectedDevicesMCatalog;
  selectedDevicesStaff;
  selectedProducts;
  showButton;
  basicDataForm = new FormGroup({
    image: new FormControl(null, Validators.required),
    active: new FormControl(true),
    name: new FormControl(null, Validators.required),
    position: new FormControl(1, Validators.required),
    backgroundColor: new FormControl('#000000'),
    textColor: new FormControl('#000000'),
    printInmediately: new FormControl(null, Validators.required)
  });
  addNewCatalogSubscription: Subscription;
  getCatalogDevicesMCatalogSubscription: Subscription;
  getCatalogDevicesStaffSubscription: Subscription;
  getCatalogDesksSubscription: Subscription;
  getProductsSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private userStorageService: UserStorageService,
              private catalogsService: CatalogsService,
              private dialog: MatDialog,
              private productsService: ProductsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private spinnerService: SpinnerService) {
                this.showButton = true;
              }

  ngOnInit() {
    this.centers = this.userStorageService.getCenterList();
    this.getProducts();
  }

  public addNewCatalog() {
    this.showButton = false;
    this.spinnerService.show('catalog-new-spinner');

    const validation = this.validateForm();
    if (validation === true) {
      this.addNewCatalogSubscription = this.catalogsService.addNewCatalog(this.basicDataForm).pipe(
        tap(o => this.catalogsService.updateCatalogCenters(o.id, this.getCatalogCentersInternalIds(this.selectedCenters)).subscribe()),
        tap(o => this.catalogsService.updateCatalogDesks(o.id, this.getCatalogDesksInternalIds(this.selectedDesks)).subscribe()),
        tap(o => this.catalogsService.updateCatalogDevicesMCatalog(o.id, this.getCatalogDevicesInternalIds(this.selectedDevicesMCatalog)).subscribe()),
        tap(o => this.catalogsService.updateCatalogDevicesStaff(o.id, this.getCatalogDevicesInternalIds(this.selectedDevicesStaff)).subscribe()),
        tap(o => this.catalogsService.updateCatalogProducts(o.id, this.getCatalogProductsInternalIds(this.selectedProducts)).subscribe()),
        tap(o => this.snackbarService.open('catalogs-page.snackbar messages.add catalog success', 'success')),
        tap(o => this.spinnerService.hide('catalog-new-spinner')),
        tap(o => this.router.navigate(['/catalog/catalogs'], { relativeTo: this.activatedRoute })),
        catchError(error => { this.spinnerService.hide('catalog-new-spinner'); this.snackbarService.open(error['error']['message'], 'error'); this.showButton = true; return empty(); })
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('catalog-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('image').valid) {
      return 'catalogs-page.snackbar messages.image catalogs error';
    } else if (!this.basicDataForm.get('name').valid) {
      return 'catalogs-page.snackbar messages.name catalog error';
    } else if (!this.basicDataForm.get('position').valid) {
      return 'catalogs-page.snackbar messages.position catalog error';
    } else {
      return true;
    }
  }

  public centersDuallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
      this.getCatalogDesks(this.getCatalogCentersInternalIds(this.selectedCenters));
      this.getCatalogDevicesMCatalog(this.getCatalogCentersInternalIds(this.selectedCenters));
      this.getCatalogDevicesStaff(this.getCatalogCentersInternalIds(this.selectedCenters));
    }
  }

  public desksDuallistboxOutputEventReceiver(selectedDesks) {
    const aux = new Array();
    for (const d of selectedDesks) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDesks = aux;
    }
  }

  public devicesMCatalogDuallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevicesMCatalog = aux;
    }
  }

  public devicesStaffDuallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevicesStaff = aux;
    }
  }

  public productsDuallistboxOutputEventReceiver(selectedProducts) {
    const aux = new Array();
    for (const d of selectedProducts) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedProducts = aux;
    }
  }

  public getCatalogCentersInternalIds(centers) {
    if (centers) {
      return centers.map(c => c.InternalId);
    }
    return [];
  }

  public getCatalogDesksInternalIds(desks) {
    if (desks) {
      return desks.map(d => d.TurnDeskInternalId);
    }
    return [];
  }

  public getCatalogDevicesInternalIds(devices) {
    if (devices) {
      return devices.map(d => d.InternalId);
    }
    return [];
  }

  public getCatalogProductsInternalIds(products) {
    if (products) {
      return products.map(p => p.InternalId);
    }
    return [];
  }

  public cancelCatalog() {
    this.router.navigate(['/catalog/catalogs'], { relativeTo: this.activatedRoute });
  }

  public getCatalogDevicesMCatalog(centerInternalIds) {
    this.getCatalogDevicesMCatalogSubscription = this.catalogsService.getCatalogDevicesMCatalog(centerInternalIds).pipe(
      tap(o => this.mCatalogDevices = o)
    ).subscribe();
  }

  public getCatalogDevicesStaff(centerInternalIds) {
    this.getCatalogDevicesStaffSubscription = this.catalogsService.getCatalogDevicesStaff(centerInternalIds).pipe(
      tap(o => this.staffDevices = o)
    ).subscribe();
  }

  public getCatalogDesks(centerInternalIds) {
    this.getCatalogDesksSubscription = this.catalogsService.getCatalogDesks(centerInternalIds).pipe(
      tap(o => this.desks = o)
    ).subscribe();
  }

  public getProducts() {
    this.getProductsSubscription = this.productsService.getProductsList().pipe(
      tap(o => this.products = o)
    ).subscribe();
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.basicDataForm.patchValue({
            image: result[0].Url
          });
        }
    });
  }

  ngOnDestroy() {
    if (this.addNewCatalogSubscription) { this.addNewCatalogSubscription.unsubscribe(); }
    if (this.getCatalogDevicesMCatalogSubscription) { this.getCatalogDevicesMCatalogSubscription.unsubscribe(); }
    if (this.getCatalogDevicesStaffSubscription) { this.getCatalogDevicesStaffSubscription.unsubscribe(); }
    if (this.getCatalogDesksSubscription) { this.getCatalogDesksSubscription.unsubscribe(); }
    if (this.getProductsSubscription) { this.getProductsSubscription.unsubscribe(); }
  }
}
